/** Never persist OP/session tokens from API JSON in the Auth SPA. */

const TOKEN_KEYS = new Set([
  "accessToken",
  "refreshToken",
  "idToken",
  "access_token",
  "refresh_token",
  "id_token",
  "rawRefreshToken",
]);

export const stripAuthTokensFromClientPayload = <T>(value: T): T => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return value;
  const out: Record<string, unknown> = {};
  for (const [key, v] of Object.entries(value as Record<string, unknown>)) {
    if (TOKEN_KEYS.has(key)) continue;
    out[key] =
      v && typeof v === "object" && !Array.isArray(v)
        ? stripAuthTokensFromClientPayload(v)
        : v;
  }
  return out as T;
};
